import * as React from 'react';

const AccessDeniedIcon: React.FC = () => (
	<svg
		width='87'
		height='84'
		viewBox='0 0 87 84'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M13.2334 11.5124C12.7731 11.5124 12.4 11.1393 12.4 10.679C12.4 10.2188 12.7731 9.8457 13.2334 9.8457'
			stroke='#B5D5EA'
			stroke-width='3.33333'
		/>
		<path
			d='M13.2334 11.5124C13.6936 11.5124 14.0667 11.1393 14.0667 10.679C14.0667 10.2188 13.6936 9.8457 13.2334 9.8457'
			stroke='#B5D5EA'
			stroke-width='3.33333'
		/>
		<path
			d='M19.8333 11.5104C19.3731 11.5104 19 11.1373 19 10.6771C19 10.2169 19.3731 9.84375 19.8333 9.84375'
			stroke='#B5D5EA'
			stroke-width='3.33333'
		/>
		<path
			d='M19.8333 11.5104C20.2935 11.5104 20.6666 11.1373 20.6666 10.6771C20.6666 10.2169 20.2935 9.84375 19.8333 9.84375'
			stroke='#B5D5EA'
			stroke-width='3.33333'
		/>
		<path
			d='M26.5333 11.5104C26.0731 11.5104 25.7 11.1373 25.7 10.6771C25.7 10.2169 26.0731 9.84375 26.5333 9.84375'
			stroke='#B5D5EA'
			stroke-width='3.33333'
		/>
		<path
			d='M26.5333 11.5104C26.9936 11.5104 27.3667 11.1373 27.3667 10.6771C27.3667 10.2169 26.9936 9.84375 26.5333 9.84375'
			stroke='#B5D5EA'
			stroke-width='3.33333'
		/>
		<path
			d='M64.6067 80.6641C75.6524 80.6641 84.6067 71.7097 84.6067 60.6641C84.6067 49.6184 75.6524 40.6641 64.6067 40.6641C53.561 40.6641 44.6067 49.6184 44.6067 60.6641C44.6067 71.7097 53.561 80.6641 64.6067 80.6641Z'
			fill='#B5D5EA'
			stroke='#B5D5EA'
			stroke-width='3.33333'
			stroke-linecap='round'
			stroke-linejoin='round'
		/>
		<path
			d='M2 17.3457H68.6667'
			stroke='#0973BA'
			stroke-width='3.33333'
			stroke-linecap='round'
			stroke-linejoin='round'
		/>
		<path
			d='M28.6667 57.3333H8.66667C6.89854 57.3333 5.20287 56.631 3.95261 55.3807C2.70238 54.1303 2 52.4347 2 50.6667V10.6667C2 8.89857 2.70238 7.20287 3.95261 5.95263C5.20287 4.70238 6.89854 4 8.66667 4H62C63.768 4 65.4637 4.70238 66.714 5.95263C67.9643 7.20287 68.6667 8.89857 68.6667 10.6667V34'
			stroke='#0973BA'
			stroke-width='3.33333'
			stroke-linecap='round'
			stroke-linejoin='round'
		/>
		<path
			d='M58.6067 80.6641C69.6524 80.6641 78.6067 71.7097 78.6067 60.6641C78.6067 49.6184 69.6524 40.6641 58.6067 40.6641C47.561 40.6641 38.6067 49.6184 38.6067 60.6641C38.6067 71.7097 47.561 80.6641 58.6067 80.6641Z'
			stroke='#0973BA'
			stroke-width='3.33333'
			stroke-linecap='round'
			stroke-linejoin='round'
		/>
		<path
			d='M44.4667 74.8068L72.7533 46.5234'
			stroke='#0973BA'
			stroke-width='3.33333'
			stroke-linecap='round'
			stroke-linejoin='round'
		/>
		<path
			d='M12 11.5124C11.5397 11.5124 11.1666 11.1393 11.1666 10.679C11.1666 10.2188 11.5397 9.8457 12 9.8457'
			stroke='#0973BA'
			stroke-width='3.33333'
		/>
		<path
			d='M12 11.5124C12.4602 11.5124 12.8333 11.1393 12.8333 10.679C12.8333 10.2188 12.4602 9.8457 12 9.8457'
			stroke='#0973BA'
			stroke-width='3.33333'
		/>
		<path
			d='M18.6667 11.5104C18.2065 11.5104 17.8334 11.1373 17.8334 10.6771C17.8334 10.2169 18.2065 9.84375 18.6667 9.84375'
			stroke='#0973BA'
			stroke-width='3.33333'
		/>
		<path
			d='M18.6667 11.5104C19.1269 11.5104 19.5 11.1373 19.5 10.6771C19.5 10.2169 19.1269 9.84375 18.6667 9.84375'
			stroke='#0973BA'
			stroke-width='3.33333'
		/>
		<path
			d='M25.3333 11.5104C24.8731 11.5104 24.5 11.1373 24.5 10.6771C24.5 10.2169 24.8731 9.84375 25.3333 9.84375'
			stroke='#0973BA'
			stroke-width='3.33333'
		/>
		<path
			d='M25.3333 11.5104C25.7935 11.5104 26.1666 11.1373 26.1666 10.6771C26.1666 10.2169 25.7935 9.84375 25.3333 9.84375'
			stroke='#0973BA'
			stroke-width='3.33333'
		/>
	</svg>
);

export default AccessDeniedIcon;
